<script lang="ts">
    import  * as Card from "$lib/components/ui/card";
    import { Button } from "$lib/components/ui/button";
    import { CircleChevronLeft } from 'lucide-svelte';
    import { createEventDispatcher } from "svelte";
    import { ChevronRight } from 'lucide-svelte';
    import { ChevronLeft } from 'lucide-svelte';
    import FullscreenDiv from "$lib/my-components/FullscreenDiv.svelte";
    import PictureTouch from "$lib/my-components/PictureTouch.svelte";
    import PdfViewer from "$lib/my-components/PdfViewer.svelte";
    import { useDocumentFile } from "../hooks/useDocumentFile";
    import { useDocument } from "../hooks/useDocument";
    import * as Alert from "$lib/components/ui/alert/index.js";
    import { t  } from 'svelte-i18n'

    import EditDocument from "../edit/edit-document.svelte";
    import DeleteDocument from "../edit/delete-document.svelte";
  
    export let onBack;

    export let groupStoreId: number
    export let projectId: number
    export let selectedDocumentId: string | undefined

    $: queryFile = selectedDocumentId == null ? null : useDocumentFile(groupStoreId, projectId, selectedDocumentId)
    $: queryMeta = selectedDocumentId == null ? null : useDocument(groupStoreId, projectId, selectedDocumentId)

    const dispatch = createEventDispatcher();
    const nextDocument = () => {
      dispatch('nextDocument');
    };

    const previousDocument = () => {
      dispatch('previousDocument');
    };

</script>


<Card.Root class="flex flex-col h-full max-h-full justify-center">
    <Card.Header>
         <Card.Title>
            {#if $queryMeta?.data}
              {#if onBack}
                <div class="flex-shrink md:hidden pb-2">
                  <Button size="sm" class="h-7 gap-1 mr-5"  on:click={onBack}>
                    <CircleChevronLeft class="h-3.5 w-3.5" />
                    <span class=" sm:whitespace-nowrap truncate">
                      {$t('global.messages.back')}
                    </span>
                  </Button>
                </div>
              {/if}
              <div class="flex-1 flex flex-row">
                <div class="truncate m-2">
                    {$queryMeta.data.title}
                </div>
                <div class="flex flex-row gap-2">
                  <EditDocument groupStoreId={groupStoreId} projectId={projectId} document={$queryMeta.data} />
                  <DeleteDocument groupStoreId={groupStoreId} projectId={projectId} documentId={$queryMeta.data.id} />
                </div>
              </div>
            {/if}
        </Card.Title> 
    </Card.Header>
    <Card.Content class="flex-grow flex flex-col justify-between items-center max-h-full max-w-full p-1 overflow-hidden">
      {#if selectedDocumentId}
        <FullscreenDiv let:onToggle>
          <div class="flex justify-between items-center h-full w-full overflow-hidden">
            <Button variant="outline" class="hidden md:flex rounded-full w-10 h-10 p-0 flex-shrink-0 " on:click={previousDocument}>
              <ChevronLeft />
            </Button>
            {#if $queryFile?.isError }
              <div> {$queryFile?.error?.message}</div>
            {:else if $queryFile?.data} 
              {#if $queryFile.data.mimeType.includes("image") }
                <PictureTouch imageUrl={$queryFile.data.url} 
                  on:swipeLeft={previousDocument} 
                  on:swipeRight={nextDocument} 
                  on:doubleTap={onToggle}
                  />
              {:else if $queryFile.data.mimeType.includes("pdf") }
                <PdfViewer pdfUrl={$queryFile.data.url} />
              {:else}
                <div>
                  format {$queryFile.data.mimeType} is actually not supported
                </div>
              {/if}
            {/if}
            <Button variant="outline" class="hidden md:flex rounded-full w-5 md:w-10 h-10 p-0 flex-shrink-0 " on:click={nextDocument}>
              <ChevronRight />
            </Button>
          </div>
        </FullscreenDiv>
        <div class="flex justify-center items-center gap-10 py-2">
          <Button variant="outline" class="md:hidden rounded-full w-10 h-10 p-0 flex-shrink-0 " on:click={previousDocument}>
            <ChevronLeft />
          </Button>
          <Button variant="outline" class="md:hidden rounded-full w-10 h-10 p-0 flex-shrink-0 " on:click={nextDocument}>
            <ChevronRight />
          </Button>
        </div>
      {:else}
        <div class="flex h-full items-center justify-center">
          <Alert.Root class="m-10 max-w-sm">
            <Alert.Title> {$t('global.messages.tip')}</Alert.Title>
            <Alert.Description>
              {$t('global.messages.app-tips.select-item-leftmenu')}
            </Alert.Description>
          </Alert.Root>
        </div>
      {/if}
    </Card.Content>
  </Card.Root>

  
